<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mtb-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>اسم المهمة</label>
                      <md-input v-model="taskName"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-checkbox v-model="isTaskLocationRequired">
                      طلب إثبات موقع
                    </md-checkbox>
                  </div>
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-checkbox v-model="isTaskPictureRequired">
                      طلب إثبات صورة
                    </md-checkbox>
                  </div>

                  <div
                    class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                  >
                    <md-button @click="saveToDB" class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >

                    <md-button @click="clear" class="md-info btn_nanosoft"
                      >جديد</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <md-table
            :value="tableData"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="اسم المهمة">{{
                item.taskName
              }}</md-table-cell>
              <md-table-cell md-label="طلب إثبات موقع">{{
                item.isTaskLocationRequired ? "نعم" : "لا"
              }}</md-table-cell>
              <md-table-cell md-label="طلب إثبات صورة">{{
                item.isTaskPictureRequired ? "نعم" : "لا"
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  async created() {
    this.init();
  },

  data() {
    return {
      id: null,
      taskName: null,
      isTaskLocationRequired: false,
      isTaskPictureRequired: false,
      tableData: [],
    };
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async saveToDB() {
      try {
        if (!this.taskName) {
          this.notifyVue("top", "center", "warning", "يرجى إدخال اسم المهمة");
          return;
        }

        const schema = {
          taskName: this.taskName,
          isTaskLocationRequired: this.isTaskLocationRequired,
          isTaskPictureRequired: this.isTaskPictureRequired,
        };

        let result = null;

        if (this.id) {
          const { data } = await this.$axios.put(
            `api/TypesOfTasks/${this.id}`,
            schema
          );
          result = data;
        } else {
          const { data } = await this.$axios.post("api/TypesOfTasks", schema);
          result = data;
        }

        if (result.message) {
          this.notifyVue("top", "center", "success", result.message);
          this.init();
          this.clear();
        }
      } catch (error) {
        if (error.response.data.errors) {
          let result =
            error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ];
          return this.notifyVue("top", "center", "danger", result[0]);
        }
        this.notifyVue("top", "center", "danger", error.message);
      }
    },

    async init() {
      try {
        const { data } = await this.$axios.get(`/api/TypesOfTasks`);
        this.tableData = data.data;
      } catch (error) {
        this.message(error);
      }
    },

    clear() {
      this.id = null;
      this.taskName = null;
      this.isTaskLocationRequired = false;
      this.isTaskPictureRequired = false;
    },

    handleEdit(item) {
      this.taskName = item.taskName;
      this.isTaskLocationRequired = item.isTaskLocationRequired;
      this.isTaskPictureRequired = item.isTaskPictureRequired;
      this.id = item.id;
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            const { data } = await this.$axios.delete(
              `/api/TypesOfTasks/${item.id}`
            );
            if (data.message) {
              this.notifyVue("top", "center", "success", data.message);
              this.init();
            }
          } catch (error) {}
        }
      });
    },
  },
};
</script>
